import * as angular from "angular";
import * as _ from "lodash";


export class TimeFiltersService {
  list: any = [
    {
      title: 'Today',
      fun: this.today,
      active: 'true'
    },
    {
      title: 'Yesterday',
      fun: this.yesterday
    },
    {
      title: 'Tomorrow',
      fun: this.tomorrow,
      active: 'true'
    },
    {
      title: 'Last 7 Days',
      fun: this.lastSevenDays
    },
    {
      title: 'Next 7 Days',
      fun: this.nextSevenDays,
      active: 'true'
    },
    {
      title: 'Last 30 Days',
      fun: this.lastThirtyDays
    },
    {
      title: 'Custom',
      fun: this.custom,
      active: 'true'
    }
  ];

  constructor(private $mdDialog, private moment) {
  }

  getThisMonth() {
    return {
      name: "This Month",
      dateStart: this.moment().startOf('month').valueOf(),
      dateEnd: new Date().getTime()
    }
  }

  getActiveList() {
    let res = [];
    _.map(this.list, (elem) => {
      if (elem.active) {
        res.push(elem);
      }
    });

    return res;
  }

  findByTitle(title) {
    return _.find(this.list, (elem) => {
      return elem.title === title;
    });
  }

  tomorrow() {
    return {
      from: this.moment().add(1, 'day').hour(0).minute(0).seconds(0).valueOf(),
      to: this.moment().add(1, 'day').hour(23).minute(59).second(59).valueOf()
    };
  }

  today() {
    return {
      from: this.moment().hour(0).minute(0).seconds(0).valueOf(),
      to: this.moment().hour(23).minute(59).second(59).valueOf()
    };
  }

  yesterday() {
    return {
      from: this.moment().add(-1, 'day').hour(0).minute(0).seconds(1).valueOf(),
      to: this.moment().add(-1, 'day').hour(23).minute(59).second(59).valueOf()
    };
  }

  lastSevenDays() {
    return {
      from: this.moment().add(-7, 'day').hour(0).minute(0).seconds(0).valueOf(),
      to: this.moment().hour(23).minute(59).second(59).valueOf()
    };
  }


  lastThirtyDays() {
    return {
      from: this.moment().add(-30, 'day').hour(0).minute(0).seconds(0).valueOf(),
      to: this.moment().hour(23).minute(59).second(59).valueOf()
    };
  }

  nextSevenDays() {
    return {
      from: this.moment().hour(0).minute(0).seconds(0).valueOf(),
      to: this.moment().add(7, 'day').hour(23).minute(59).seconds(59).valueOf()
    };
  }

  custom(ev, currentTimeSelected) {
    return this.$mdDialog.show({
      template: '<custom-from-to current-time-selected="currentTimeSelected"></custom-from-to>',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: true,
      controller: function ($scope) {
        $scope.currentTimeSelected = currentTimeSelected;
      }
    });
  }
}

angular
  .module('bringoz.admin.commons')
  .service('timeFiltersService', TimeFiltersService);
